import { render, staticRenderFns } from "./CreateOasisSoftwareUpdateDialog.vue?vue&type=template&id=4e84b6c8"
import script from "./CreateOasisSoftwareUpdateDialog.vue?vue&type=script&lang=js"
export * from "./CreateOasisSoftwareUpdateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports